<template>
    <div class="table">
        <div class="table--row table--header">
            <div class="table--type"></div>
            <div class="table--cell table--border border--radius--tl border--left">F1</div>
            <div class="table--cell table--border">F2</div>
            <div class="table--cell table--border border--radius--tr">F3</div>
        </div>
        <div v-for="type in ['X', 'Y']" :key="type" class="table--row">
            <div class="table--type table--border border--left"
                :class="{
                    'border--radius--tl' : type == 'X',
                    'border--radius--bl' : type == 'Y'
                }"
            >
                {{type}}p
            </div>
            <div class="table--cell table--border" v-for="n in 3" :key="n" :class="{'border--radius--br' : type == 'Y' && n == 3}">
                <div class="circle" v-if="shouldRenderCircle(type, n)" :style="getAdvicePosition()"></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name : "MattressAdvice",
    props: {
        result: {
            type: Object
        }
    },

    methods: {
        getAdvicePosition() {
            if (this.result.MattressAdviceXpYp !== null && this.result.MattressAdviceFType) {
                //values from 1-3, map to % (3*22 +18)
                let x = (parseInt(this.result.MattressAdviceFType[3]) - .5) * 22 + 18;
                let y = (parseInt(this.result.MattressAdviceXpYp[2]) - .5) * 22 + 18;

                const mattressAdvice = this.result.MattressAdviceXpYp[0];
                if (mattressAdvice === "X") {
                    y = 100 - y;
                }

                return {"left": x + "%", "top" : y + "%"};
            }
            return {};
        },

        shouldRenderCircle(type, col) {
            if (this.result.MattressAdviceXpYp && this.result.MattressAdviceFType) {
                return this.result.MattressAdviceXpYp[0] === type && parseInt(this.result.MattressAdviceFType[1]) === col;
            }
            return false;
        }
    }
};
</script>

<style lang="scss" scoped>
    $headerHeight : 2rem;

    .circle {
        $size : 1.5rem;
        margin-left : math.div(-$size, 2);
        margin-top : math.div(-$size, 2);
        width : $size;
        height : $size;
        background-color : $color-blue;
        border : solid .35rem #8c8eaa;
        border-radius: 50%;
        position: absolute;
    }

    .table {
        width : 100%;
        $border : solid .1rem #6F6F6E;
        color : #6F6F6E;
        height: 12.1rem;

        &--row {
            display: flex;
            position: relative;
            height : 5.1rem;

            &:last-child > div {
                border-bottom : $border;
            }

            & > div:last-child  {
                border-right : $border;
            }
        }

        &--header {
            height : $headerHeight;
            text-align: center;
            line-height: $headerHeight;
        }

        &--type {
            width : 18%;
            font-size : 1.25em;
            line-height: 2.6em;
            text-align: center;
            display: flex;
            justify-content: center;
            align-items: center;

        }
        &--cell {
            width: 28%;
            position: relative;
        }

        &--border {
            border-left : $border;
            border-top : $border;
        }

        .border--left {
            border-left : $border;
        }
    }

    .border--radius--tl {
        border-radius: 1rem 0 0 0;
    }

    .border--radius--bl {
        border-radius: 0 0 0 1rem;
    }

    .border--radius--br {
        border-radius: 0 0 1rem 0;
    }

    .border--radius--tr {
        border-radius: 0 1rem 0 0;
    }

    // .line {
    //     position: absolute;
    //     border-bottom: dotted 2px black;
    //     width: 72%;
    //     left: 23%;
    //     top: 50%;
    // }

</style>